// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"zO-z","carouselContainer":"AO-z"};